module.exports = __webpack_public_path__ + "officialStatic/img/case-hs.430f89d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-hs.jpg
// module id = RIQi
// module chunks = 0